import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { UrlParamNames } from "constants/url-param-names";
import { useConversationActions } from "./use-conversation-actions.hook";

/**
 * Loads a conversation from the `conversationId` URL query param, if present, and strips
 * the param from the URL afterward. Resolves the current conversation atom from whichever
 * `CurrentConversationProvider` ancestor is in scope.
 */
export function useLoadConversationFromUrl(): { foundParam: boolean } {
    const { loadConversation } = useConversationActions();
    const { search, pathname, hash } = useLocation();
    const history = useHistory();

    const [foundParam, setFoundParam] = useState(false);

    useEffect(() => {
        const query = new URLSearchParams(search);
        const conversationId = query.get(UrlParamNames.ConversationId);
        if (conversationId) {
            setFoundParam(true);
            loadConversation(conversationId);

            query.delete(UrlParamNames.ConversationId);
            history.replace({ pathname, search: query.toString(), hash });
        } else {
            setFoundParam(false);
        }
    }, [hash, history, loadConversation, pathname, search]);

    return { foundParam };
}
